import { icons } from '../components/Icons';
import { CustomPaper } from '../components/Layout/CustomPaper';
import { authClient } from '../lib/authClient';
import { routes } from '../routes';
import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { Anchor, Button, Space, TextInput, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React from 'react';
import { useForm } from 'react-hook-form';
import { Link, useLocation } from 'wouter';
import { z } from 'zod/v4';

const schema = z.object({ email: z.email() });

export const ForgetPassword: React.FC = () => {
  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
  } = useForm<z.infer<typeof schema>>({
    resolver: standardSchemaResolver(schema),
  });

  const [, navigate] = useLocation();

  const submitHandler = handleSubmit(async (data) => {
    // authClient.forgetPassword({
    //   email: data.email,
    // });

    const { error } = await authClient.signIn.magicLink({
      // callbackURL: routes.resetPassword, // redirect after successful login (optional)
      email: data.email,
      fetchOptions: {
        query: { mode: 'reset-password' },
      },
    });

    if (error) {
      showNotification({
        message: (
          <>
            <icons.Failure />
            {error.message || 'Unknown error, please try again'}
          </>
        ),
      });
    } else {
      showNotification({
        message: (
          <>
            <icons.Success />
            Password reset email sent
          </>
        ),
      });

      navigate(routes.signIn, {
        replace: true,
      });
    }
  });

  return (
    <CustomPaper>
      <Title order={3}>Password recovery</Title>
      <Space h="sm" />
      <form
        noValidate
        onSubmit={submitHandler}
      >
        <TextInput
          error={errors?.email?.message?.toString()}
          label="Email address"
          type="email"
          {...register('email', {
            required: 'Please provide an email address',
          })}
        />
        <Space h="md" />
        <Button
          disabled={isSubmitting}
          loading={isSubmitting}
          type="submit"
        >
          Submit
        </Button>
      </form>
      <Space h="xl" />
      <Anchor
        component={Link}
        to={routes.signIn}
      >
        Sign in
      </Anchor>
    </CustomPaper>
  );
};
